module.exports = __webpack_public_path__ + "static/media/mechanics.02ba850d.jpg";